WiseMetering.Collection.CircuitTags = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.CircuitTag,
    url: '/circuit_tags'
});
